<template>
	<div class="d-flex flex-column h-100">
		<!-- Header -->
		<nav class="navbar navbar-expand-lg navbar-light bg-light transition-color" :class="getColor()">
			<div class="d-flex flex-row">
				<ul v-if="user" class="nnav align-items-center tablet-float-left mb-0">
					<!-- User Dropdown -->
					<li class="dropdown d-flex align-items-center mt-1">
						<a
							data-toggle="dropdown"
							class="d-flex align-items-center hamburger-menu"
							data-pjax-click-state="anchor-empty"
							aria-expanded="false"
						>
							<button class="no-select d-flex align-items-center btn navbar-btn solid-outline">
								<img
									class="hamburger-icon"
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABaklEQVR4Xu2aTUoDQRCFv2yNP9cInsCtbkWCl9EraE4jwWXIVo8gXiIkxL0URNBON3Yyq6p6s00z9Hv1VVdPpUYkf0bJ9SMDREByB5QCyQHQIagUUAokd0Ap0ABgAjwBN8CZc0i+gCXwAHyUWmoEmPh34MK58HL7a+CqNKFmwAswDSb+R8681FYzYBMA+1b8tqW2mgG2aByUgC4DDJO7oAZYet//1pbpEFztDsHP/wyw360SPO/K4KlzGgz7BfAI/BFvunQRch7dwdsXAYMtdP4CEeA8gIO3LwIGW+j8BS0CLoEZcA2cONd4cD/AxL8B586FH90PeAVug4k/qB9gyHjHXv2AhgPqB6gfUHwSt8qg+gFBq8CeLF2Fs0S6pVMEiIDkDigFkgPQ/F9A/QD1A2LmRtd8gPoBmg/QfEDIISnNB2g+oFLZdBWOWe77VYmAfq9irhQBMePar0oE9HsVc6UIiBnXflXpCfgGC8dCQbbkoGgAAAAASUVORK5CYII="
								/>
							</button>
						</a>
						<div class="dropdown-menu dropdown-menu-left pt-0 mt-2 animate fadeIn text-md">
							<div class="row no-gutters b-b mb-2"></div>
							<div v-if="user" class="dropdown-item disabled d-flex flex-row align-items-center">
								<i class="fas fa-2x fa-user ml-1 mr-4" :class="{ [fs.roleIcon(user.role)]: true }"></i>
								<div class="flex">
									<a class="text-md _600">{{ fs.displayName(user.name) }}</a>
									<div class="text-muted">University of Iowa</div>
									<div class="text-muted">{{ user.email }}</div>
								</div>
							</div>
							<template v-if="user && (user.role != 'STUDENT' || user.role == 'PARTNER')">
								<div class="dropdown-divider"></div>
								<a v-if="user.role == 'ADMIN'" class="dropdown-item" href="#/admin">
									<span>Admin Console</span>
								</a>
								<a class="dropdown-item" href="#/classes">
									<span>Choose Class</span>
								</a>
								<a class="dropdown-item" href="#/class_details">
									<span>Class Details</span>
								</a>
							</template>
							<template v-if="user && (user.role == 'STUDENT' || user.role == 'PARTNER')">
								<div class="dropdown-divider"></div>
								<div class="mx-4 text-muted">{{ getSectionName() }}</div>
								<a
									v-if="user.sections && user.sections.length > 0"
									class="dropdown-item"
									href="#/classes"
								>
									<span>Choose Class</span>
								</a>
								<button
									v-if="user.sections && user.sections.length > 0"
									class="dropdown-item"
									v-b-modal.joinClassModal
								>
									<span>Join New Class</span>
								</button>
							</template>
							<div class="dropdown-divider"></div>
							<a class="dropdown-item" href="/#/account">Profile</a>
							<a class="dropdown-item" href="https://jacobsoninstitute.org/STEM-Innovator" target="_blank"
								>About Us</a
							>
							<a
								class="dropdown-item"
								href="https://mzscore.zendesk.com/hc/en-us/categories/360004412293-STEM-Innovator-Help-Documents"
								target="_blank"
								>Need help?</a
							>
							<div class="dropdown-divider"></div>
							<a class="dropdown-item" @click="logout">Sign out</a>
						</div>
					</li>
				</ul>
				<a>
					<div class="logo">
						<img class="logo-img" :src="brand.header_logo" />
					</div>
				</a>
			</div>
			<div class="title flex">
				<slot name="title"></slot>
			</div>
		</nav>

		<!-- Content -->
		<div class="flex app-content d-flex flex-content scroll-y" id="main-page-scroll">
			<div class="flex" :class="getBGColor()">
				<slot></slot>
			</div>
		</div>

		<b-modal id="versionModal" no-close-on-backdrop no-close-on-esc>
			<template slot="modal-header">
				<h5 class="modal-title pl-4">New Version Detected</h5>
			</template>
				<p class="p-4">We've detected a new version of STEM Innovator®. Please refresh to get the latest version.</p>
			<template slot="modal-footer">
				<button @click="reload()" class="btn btn-flat btn-success">Refresh</button>
			</template>
		</b-modal>

		<!-- Footer -->
		<div class="full-stripe row no-gutters footer" :class="getColor()" style="flex-wrap: wrap;">
			<slot name="footer"></slot>
			<div class="text-left" style="flex: 1;">© 2023 Copyright MZ Development v{{ version }}</div>
		</div>

		<!-- Join class modal -->
		<b-modal id="joinClassModal" headerClass="indigo" size="md">
			<template v-slot:modal-title>
				<h3 class="modal-title full-bar-title">Join New Class</h3>
			</template>
			<div class="p-2">
				<label class="si-font large-label mb-4" style="font-size: 40px">Enter Join Code:</label>
				<input
					ref="codeInput"
					class="form-control text-center black-border code-entry"
					:class="{ 'is-invalid': codeFailed }"
					v-model="code"
				/>
			</div>
			<template v-slot:modal-footer="{ _, cancel }">
				<button type="button" class="btn btn-secondary" @click="cancel">Cancel</button>
				<button v-if="!joining && !validCode" @click="applyJoinCode()" class="btn btn-primary" disabled>
					Join Class
				</button>
				<button v-if="!joining && validCode" @click="applyJoinCode()" class="btn btn-primary">
					Join Class
				</button>
				<button v-if="joining" class="btn btn-secondary" disabled>
					Checking Code...
					<loading type="icon" />
				</button>
			</template>
		</b-modal>
	</div>
	
</template>

<script>
import AuthService from "@/services/AuthService";
import BrandService from "@/services/BrandService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import pkg from "../../package.json"
import _ from "lodash";

export default {
	name: "MainPage",

	props: {
		user: {},
		color: {},
		fillBackground: {
			type: Boolean,
			default: false,
		},
		hideFooter: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			fs: fs,
			code: null,
			joining: false,
			codeFailed: null,

			brand: BrandService.getBrand(),
			version: pkg.version,
			newVersion: false,
		};
	},
	created() {
		this.checkVersion();
	},
	computed: {
		validCode() {
			return this.code && this.code.length == 12;
		},
	},

	methods: {
		logout() {
			AuthService.logout(this);
		},

		getColor() {
			if (this.brand.main_page_color) {
				this.color = this.brand.main_page_color;
			}
			switch (this.color) {
				case "yellow":
					return { "si-yellow": true };
				case "green":
					return { "si-green": true };
				case "blue":
					return { "si-blue": true };
				case "orange":
					return { "si-orange": true };
				case "gray":
					return { "si-gray": true };
				case "white":
					return { "si-white": true };
				case "black":
					return { "si-black": true };
				case "pink":
					return { "si-pink": true };
				default:
					return { "si-yellow": true };
			}
		},

		getBGColor() {
			if (!this.fillBackground) {
				return {};
			} else {
				return this.getColor();
			}
		},

		applyJoinCode() {
			AuthService.applyJoinClassCode(this.code, this.user.role)
				.then(() => {
					this.$bvModal.hide("joinClassModal")
					this.joining = false;
					AuthService.forceRefresh();
					this.goToLandingPage(this.user.role);
				})
				.catch((e) => {
					this.joining = false;
					console.log(e);
					this.codeFailed = true;
					this.$refs.codeInput.focus();
					Notie.error("Invalid class join code", e);
				});
		},

		goToLandingPage(role) {
			let dest = "/";
			switch (role) {
				case "STUDENT":
					dest = "/portfolio";
					break;
				case "TEACHER":
					dest = "/classes";
					break;
				case "PARTNER":
					dest = "/classes";
					break;
			}
			if (this.$route.path == dest) {
				window.location.reload(false);
			}
			this.$router.push(dest);
		},

		getSectionName() {
			if (!this.user.current_section_id) {
				return "(No class)";
			}

			let section = _.find(this.user.sections, { id: this.user.current_section_id });
			if (!section) {
				return "(No class)";
			}

			return section.name;
		},

		checkVersion() {
			AuthService.getVersion()
			.then((r) => {
				var serverVersion = r.data;
				if (serverVersion == this.version || serverVersion == "dev") {
					this.$bvModal.hide("versionModal");
				}
				else if (serverVersion) {
					this.$bvModal.show("versionModal");
				}
			})
			.catch((e) => {
				console.log(e);
			})
		},

		reload() {
			window.location.reload(true);
		}
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
	list-style-type: none;
	padding: 0;
}
li {
	display: inline-block;
	margin: 0 10px;
}
.hamburger-menu {
	border: 4px solid black;
	border-radius: 0.5rem;
	opacity: 0.75;
}
.hamburger-icon {
	height: 40px;
}
.logo {
	margin-top: -8px;
	margin-bottom: -2px;
}
.logo-img {
	height: 80px;
}
.title {
	font-size: 72px;
	font-family: "Blender Pro";
	color: black;
	margin-top: -16px;
	margin-bottom: -16px;
	line-height: 0.8;
	padding-top: 1.25rem;
	padding-bottom: 1.25rem;
}
.transition-color {
	transition: background-color 0.25s ease-in-out, color 0.25s ease-in-out;
}
.code-entry {
	margin-left: auto;
	margin-right: auto;
	max-width: 650px;
	font-size: 48px;
	font-family: "Blender Pro";
}
.black-border {
	border: 2px solid rgb(128, 128, 128);
}
.footer {
	flex-direction: row-reverse;
}
</style>
